/** Route path `vehicle-catalog` is allowed if the admin has any of these legacy/granular permissions. */
export const VEHICLE_CATALOG_PERMISSION_ALIASES = [
  "vehicle-catalog",
  "fuel-type",
  "ride-type",
  "vehicle-category",
] as const;

export function canAccessVehicleCatalogRoute(
  permissions: string[] | undefined,
): boolean {
  if (!permissions?.length) return false;
  return VEHICLE_CATALOG_PERMISSION_ALIASES.some((p) => permissions.includes(p));
}
